import React, { memo } from "react";

import Box from "@mui/material/Box";
import List from "@mui/material/List";
import { styled } from "@mui/material/styles";

import StopImgGalleryItem from "../StopImgGalleryItem";

const MobileWrapper = styled(Box)(({ theme }) => ({
  marginTop: "10px",
  marginBottom: "20px",
  padding: 0,
  [theme.breakpoints.up("sm")]: {
    display: "none",
  },
}));

const DesctopWrapper = styled(Box)(({ theme }) => ({
  display: "none",
  [theme.breakpoints.up("sm")]: {
    display: "block",
    position: "absolute",
    left: "20px",
    bottom: "20px",
  },
}));

const ImgsList = styled(List)(() => ({
  display: "flex",
  alignItems: "center",
  gap: "11px",
  boxSizing: "border-box",
}));

const StopImgGallery = memo(
  ({ imgs, desctop, currentImg, handleChangeImg }) => {
    return (
      <>
        {desctop ? (
          <DesctopWrapper>
            <ImgsList>
              {imgs?.map((el, i) => (
                <StopImgGalleryItem
                  img={el}
                  key={el}
                  indx={i}
                  currentImg={currentImg}
                  handleChangeImg={handleChangeImg}
                />
              ))}
            </ImgsList>
          </DesctopWrapper>
        ) : (
          <MobileWrapper>
            <ImgsList>
              {imgs?.map((el, i) => (
                <StopImgGalleryItem
                  img={el}
                  key={el}
                  indx={i}
                  currentImg={currentImg}
                  handleChangeImg={handleChangeImg}
                />
              ))}
            </ImgsList>
          </MobileWrapper>
        )}
      </>
    );
  }
);

export default StopImgGallery;
